'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var DefaultQuestions = require('./DefaultQuestions.js');
var CancelSaveButtons = require('../CancelSaveButtons.js');
var FormControl = require('../../node_modules/@material-ui/core/esm/FormControl/FormControl.js');
var InputLabel = require('../../node_modules/@material-ui/core/esm/InputLabel/InputLabel.js');
var Select = require('../../node_modules/@material-ui/core/esm/Select/Select.js');
var OutlinedInput = require('../../node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function getQuestionList(industry) {
  var questionList;

  if (industry in DefaultQuestions.frequentlyAskedQuestions) {
    questionList = DefaultQuestions.frequentlyAskedQuestions[industry];
  } else {
    questionList = DefaultQuestions.frequentlyAskedQuestions[DefaultQuestions.OTHERS];
  }

  return questionList;
}

function FaqInEdit(_ref) {
  var industry = _ref.industry,
      updatedQuestion = _ref.updatedQuestion,
      updatedAnswer = _ref.updatedAnswer,
      onSelectQuestion = _ref.onSelectQuestion,
      onChangeQuestion = _ref.onChangeQuestion,
      onChangeAnswer = _ref.onChangeAnswer,
      isSaving = _ref.isSaving,
      disabled = _ref.disabled,
      _onCancelClick = _ref.onCancelClick,
      _onSaveClick = _ref.onSaveClick,
      selectOther = _ref.selectOther;
  var questionList = getQuestionList(industry.toLowerCase());
  var inQuestionList = questionList.includes(updatedQuestion);
  var emptyQuestion = updatedQuestion === '';
  return React__default["default"].createElement("form", {
    onSubmit: function onSubmit(event) {
      return event.preventDefault();
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(FormControl["default"], {
    variant: "outlined",
    fullWidth: true
  }, React__default["default"].createElement(InputLabel["default"], null, "Question"), React__default["default"].createElement(Select["default"], {
    value: inQuestionList ? updatedQuestion : emptyQuestion && !selectOther ? '' : DefaultQuestions.CUSTOM_QUESTION,
    onChange: function onChange(event) {
      return onSelectQuestion(event);
    },
    input: React__default["default"].createElement(OutlinedInput["default"], {
      labelWidth: 88
    })
  }, questionList.map(function (question, index) {
    return React__default["default"].createElement(MenuItem["default"], {
      key: index,
      value: question
    }, question);
  })))), !inQuestionList && (!emptyQuestion || selectOther) && React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(TextField["default"], {
    fullWidth: true,
    label: "Question",
    variant: "outlined",
    onChange: function onChange(event) {
      return onChangeQuestion(event);
    },
    value: updatedQuestion,
    multiline: true,
    required: true,
    autoFocus: true
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(TextField["default"], {
    fullWidth: true,
    label: "Answer",
    variant: "outlined",
    value: updatedAnswer,
    multiline: true,
    rows: 4,
    required: true,
    onChange: function onChange(event) {
      return onChangeAnswer(event);
    }
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(CancelSaveButtons, {
    onCancelClick: function onCancelClick() {
      return _onCancelClick();
    },
    onSaveClick: function onSaveClick() {
      return _onSaveClick();
    },
    isSaving: isSaving,
    disabled: disabled
  }))));
}

FaqInEdit.defaultProps = {
  industry: 'Plumbing',
  updatedQuestion: '',
  updatedAnswer: '',
  onSelectQuestion: function onSelectQuestion() {},
  onChangeQuestion: function onChangeQuestion() {},
  onChangeAnswer: function onChangeAnswer() {},
  isSaving: false,
  disabled: false,
  onCancelClick: function onCancelClick() {},
  onSaveClick: function onSaveClick() {},
  selectOther: false
};

module.exports = FaqInEdit;
